import React from 'react';
import Section from './Section';
import { ExternalLink, Github } from 'lucide-react';

const projects = [
    {
        title: "GroceryCam",
        period: "Dec 2024 – Present",
        tags: ["Next.js", "Firebase", "Gemini API", "Vision API"],
        description: "Intelligent grocery receipt reader that digitizes items, tracks pantry inventory, and suggests budget-friendly recipes using AI.",
        link: "https://grocery-cam-app.vercel.app"
    },
    {
        title: "jobque.ai",
        period: "Aug 2024 – May 2025",
        tags: ["React.js", "Flask", "AWS"],
        description: "Full-stack job search automation platform featuring automated alerts, Google OAuth, and Stripe payment integration.",
        link: "https://jobque.ai"
    },
    {
        title: "MyReceipes",
        period: "Sep – Dec 2023",
        tags: ["SwiftUI", "Firebase", "RapidAPI"],
        description: "iOS recipe discovery app featuring cross-device synchronization and location-based grocery store finder.",
        link: "https://github.com/sriram9573/MyRecepies"
    },
    {
        title: "SMS Spam Classifier",
        period: "Jan – Feb 2025",
        tags: ["Python", "Streamlit", "ML"],
        description: "ML-powered spam detection comparing Naive Bayes and Logistic Regression models.",
        link: "https://github.com/sriram9573/sms-spam-classifier"
    },
    {
        title: "Effort Logger V2",
        period: "Sep – Nov 2023",
        tags: ["JavaFX", "MVC"],
        description: "Desktop effort tracking application with modular architecture and real-time logging.",
        link: "https://github.com/sriram9573/EffortLoggerV2.0"
    }
];

export default function Projects() {
    return (
        <Section id="projects" className="bg-warm-grey">
            <h2 className="text-3xl font-serif font-bold text-center text-charcoal mb-16">Projects</h2>

            <div className="grid md:grid-cols-2 gap-8">
                {projects.map((project, idx) => (
                    <div key={idx} className="group bg-warm-white p-8 hover:shadow-md transition-all duration-300 border border-transparent hover:border-earth-brown/30">
                        <div className="flex justify-between items-start mb-4">
                            <h3 className="text-xl font-bold text-charcoal group-hover:text-clay transition-colors">{project.title}</h3>
                            <div className="flex gap-3">
                                {/* Assuming GitHub link might exist broadly, but if not specific mostly hidden */}
                                {project.link && (
                                    <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-charcoal/40 hover:text-clay">
                                        <ExternalLink size={20} />
                                    </a>
                                )}
                            </div>
                        </div>

                        <p className="text-charcoal/70 mb-6 leading-relaxed min-h-[3rem]">
                            {project.description}
                        </p>

                        <div className="flex flex-wrap gap-2 mt-auto">
                            {project.tags.map(tag => (
                                <span key={tag} className="text-xs uppercase tracking-wider px-2 py-1 bg-warm-grey text-charcoal/60">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </Section>
    );
}
